var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfiniAiSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3071 7.52305C9.52876 8.24749 8.70399 8.93794 7.75922 9.4257C6.81445 9.91346 5.73409 10.1897 4.68052 10.045C3.32457 9.85869 2.09181 8.93994 1.52583 7.69417C0.959846 6.44839 1.07984 4.91595 1.83262 3.77332C2.00181 3.51625 2.2022 3.28077 2.4262 3.07047C3.47096 2.09376 4.97491 1.76712 6.35247 2.15013C10.5455 3.32075 12.9298 8.04919 16.9193 9.79991C17.5381 10.0654 18.2269 10.2589 18.9048 10.2737C22.2963 10.37 24.1387 5.8267 22.0283 3.2264C21.2556 2.24129 20.0208 1.68676 18.7737 1.72594C17.6533 1.75993 16.6477 2.2189 15.6938 2.80421C14.943 3.26278 14.309 3.84409 13.737 4.49416",
    stroke: "#4289D5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniAiSmallIcon);
export default __webpack_public_path__ + "static/media/infiniAiSmallIcon.a3ec4eb769b986df58a8c70f392a8c93.svg";
export { ForwardRef as ReactComponent };